<template>
  <v-card flat class="pt-2">
    <v-layout v-if="jobTimes">
      <v-flex xs2 pt-0 class="text-xs-left">
        <span class="fake-label">Time</span>
      </v-flex>
      <v-flex xs8 offset-xs1 >
        <span class="fake-label">Description</span>
      </v-flex>
    </v-layout>
    <v-layout align-end row fill-height v-for="(time, timeindex) in jobTimes"  :key="time.id">
      <v-flex xs2 pt-0 class="text-xs-left" >
        <v-text-field
          name="timeAmount"
          :id="'timeAmount-'+ listId + '-' + timeindex"
          v-model="time.timeAmount"
          required
          hide-details
          placeholder="hh:mm"
          mask="time"
          ref="linefocus"
          @focus="$event.target.select()"
          @change="updateJobTime(time, jobId)"
          @keyup.enter="updateJobTime(time, jobId)"
        ></v-text-field>
      </v-flex>
      <v-flex xs8 offset-xs1>
        <v-text-field
        name="timeText"
        :id="'timeText-'+ listId + '-' + timeindex"
        v-model="time.timeText"
        required
        placeholder=" "
        hide-details
        @change="updateJobTime(time, jobId)"
        @keyup.enter="updateJobTime(time, jobId)"
        ></v-text-field>
      </v-flex>
      <v-flex xs1 pt-0 class="text-xs-right">
        <v-icon @click="deleteJobTime(time.id, jobId)" class="small-icon error--text">close</v-icon>
      </v-flex>
    </v-layout>
    <v-layout v-if="!jobTimes || Object.keys(jobTimes).length === 0">
      <v-flex style="padding: 15px 0 0 ">
        <p class="body-small subtle">You can log the time spent on this jobs here.</p>
      </v-flex>
    </v-layout>
    <v-layout pt-2 pb-0>
      <v-flex xs4>
        <v-btn class="mt-2 text-none" small depressed @click="addJobTime()">
          + add time
        </v-btn>
      </v-flex>
      <v-flex xs6 pt-2 v-if="totalTime">
        <span class="fake-label"><strong class="fix-label">Total:</strong> {{totalTime}}</span>
      </v-flex>
    </v-layout>
    <confirm ref="confirm"></confirm>
  </v-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import Confirm from '@/components/Shared/Confirm'

export default {
  name: 'JobTimes',
  components: {
    Confirm
  },
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      user: this.$store.getters.user,
      jobTimes: this.job.times,
      jobId: this.job.id,
      listId: this.job.listId
    }
  },
  computed: {
    totalTime () {
      // start with nothing
      let totalTime = 0
      // if there are job times then..
      if (this.jobTimes) {
      // loop through all time logs and tally them
        Object.keys(this.jobTimes).forEach((key) => {
          totalTime = totalTime + Number(this.jobTimes[key].timeAmount)
        })
      }
      // grab the last two digits (minutes)
      let minutes = totalTime.toString().slice(-2)
      // grab all the other digits (hours)
      let hours = totalTime.toString().slice(0, -2)
      // total minutes modulo 60 (remainder after dividing by 60)
      let totalMins = minutes % 60
      // add the minutes to the hours
      let totalhours = parseInt(hours) + Math.floor(minutes / 60)
      // return a nice string
      if (isNaN(totalhours)) {
        return ''
      }
      return `${totalhours} hours ${totalMins} minutes`
    }
  },
  watch: {
    job (newValue) {
      // when the job updates update our component
      // when we add, delete update bring it back here
      this.jobTimes = this.job.times
    }
  },
  methods: {
    addJobTime () {
      this.$store.commit('setLoading', true)
      const listId = this.listId
      const jobId = this.jobId
      const groupId = this.user.group
      // get key
      const ref = firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/times').push().key
      // build object
      const time = {
        id: ref,
        timeText: '',
        timeAmount: '',
        creatorId: this.user.id
      }
      // update the current in-edit job in the store with the notes and new note
      this.$store.commit('setJobDetailModalJob', {
        ...this.job,
        'times': {
          ...this.jobTimes,
          [ref]: time
        }
      })
      // set with key to FB
      firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/times' + '/' + ref).set(time)
        .then((data) => {
          this.$store.commit('setLoading', false)
        })
        .catch((error) => {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        })
      this.$nextTick(() => {
        this.$refs.linefocus[this.$refs.linefocus.length - 1].focus()
      })
    },
    async deleteJobTime (timeId, jobId) {
      // confirm we want to do this
      if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
        this.$store.commit('setLoading', true)
        const group = this.user.group
        // remove the note from our local data
        this.$delete(this.jobTimes, timeId)
        // commit the jobnotes Object to the in-edit job
        this.$store.commit('setJobDetailModalJob', {
          ...this.job,
          'times': {
            ...this.jobTimes
          }
        })
        // write the changes to firebase
        firebase.database().ref('lists/' + group + '/list' + this.listId + '/' + this.jobId + '/times' + '/' + timeId).remove()
          .then((data) => {
            this.$store.commit('setLoading', false)
          })
          .catch((error) => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          })
      }
    },
    updateJobTime (time, jobId) {
      this.$store.commit('setLoading', true)
      const listId = this.listId
      const groupId = this.user.group
      // commit the jobnotes Object to the in-edit job
      this.$store.commit('setJobDetailModalJob', {
        ...this.job,
        'times': {
          ...this.jobTimes
        }
      })
      // write the changes to firebase
      firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/times' + '/' + time.id).set(time)
        .then((data) => {
          this.$store.commit('setLoading', false)
        })
        .catch((error) => {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        })
    }
  }
}
</script>

<style scoped>
.line-delete{
  flex-shrink: 0;
  flex-basis:15px;
  margin-left:5px;
}
.small-icon{
  font-size:15px;
}
</style>
